import { api } from './index';

const TITLES_API_ENDPOINT = '/authorized/titles';
export const titlesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // Titles
        getTitleById: builder.query({
            query: (titleId) => ({ url: `${TITLES_API_ENDPOINT}/${titleId}` })
        }),

        // Giveaway Codes
        getGiveawayCodesByTitleId: builder.query({
            query: ({ titleId, limit, offset }) => ({
                url: `${TITLES_API_ENDPOINT}/${titleId}/giveawaycodes`,
                params: { limit, offset }
            }),
            providesTags: () => [{ type: 'GiveawayCodes', id: 'LIST' }]
        }),
        createGiveawayCode: builder.mutation({
            query: ({ titleId, codeCount = 1 }) => ({
                url: `${TITLES_API_ENDPOINT}/${titleId}/giveawaycodes`,
                method: 'POST',
                data: { count: codeCount }
            }),
            invalidatesTags: () => [{ type: 'GiveawayCodes', id: 'LIST' }]
        })
    })
});

export const { useGetGiveawayCodesByTitleIdQuery, useCreateGiveawayCodeMutation } = titlesApi;
